import React from 'react'
import { Container } from './styles'
import logoImage from '../../assets/logo-previericsson.png'

const Logo: React.FC = () => {
  return <Container src={logoImage} alt="Aspprev" />
}

export default Logo
